import { createMarketplaceEventFactory } from '../index';
import { MarketplaceProviderInteraction } from './interactions';

export const getMarketplaceProviderInteractionEvent =
  createMarketplaceEventFactory<MarketplaceProviderInteraction>(
    'Marketplace Provider',
    'Marketplace Provider Interaction'
  );
